// src/components/ContactForm.jsx

import { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";

// ❌ BACKEND DISABLED FOR NOW
// import axiosClient from "../services/axiosClient";

export default function ContactForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  // -----------------------------
  // HANDLE INPUT CHANGE
  // -----------------------------
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // -----------------------------
  // CAPTCHA (KEEP ACTIVE)
  // -----------------------------
  const handleCaptcha = (token) => {
    // ✅ STATIC MODE: Assume captcha is valid when token exists
    if (token) {
      setCaptchaVerified(true);
    }
  };

  // -----------------------------
  // FORM SUBMISSION (STATIC)
  // -----------------------------
  const submitForm = async (e) => {
    e.preventDefault();

    if (!captchaVerified) return;

    setLoading(true);

    // ⏳ Fake delay for better UX
    setTimeout(() => {
      setLoading(false);

      // ✅ DUMMY SUCCESS POPUP
      alert("Message sent successfully");

      // Reset form
      setForm({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

      setCaptchaVerified(false);
    }, 1000);
  };

  return (
  <Box
    component="form"
    onSubmit={submitForm}
    sx={{
      maxWidth: 520,
      mx: "auto",
      p: 3,
      borderRadius: 2,
      bgcolor: "rgba(255,255,255,0.04)",
      color: "#fff",
    }}
  >
    <Typography variant="h6" mb={2} color="white">
      Send us a Message
    </Typography>

    <TextField
      fullWidth
      label="Full Name"
      name="name"
      value={form.name}
      onChange={handleChange}
      margin="dense"
      required
      InputLabelProps={{ style: { color: "#bbb" } }}
      InputProps={{ style: { color: "#fff" } }}
    />

    <TextField
      fullWidth
      label="Email"
      name="email"
      value={form.email}
      onChange={handleChange}
      margin="dense"
      required
      InputLabelProps={{ style: { color: "#bbb" } }}
      InputProps={{ style: { color: "#fff" } }}
    />

    <TextField
      fullWidth
      label="Phone"
      name="phone"
      value={form.phone}
      onChange={handleChange}
      margin="dense"
      InputLabelProps={{ style: { color: "#bbb" } }}
      InputProps={{ style: { color: "#fff" } }}
    />

    <TextField
      fullWidth
      label="Message"
      name="message"
      value={form.message}
      onChange={handleChange}
      margin="dense"
      multiline
      rows={3}
      required
      InputLabelProps={{ style: { color: "#bbb" } }}
      InputProps={{ style: { color: "#fff" } }}
    />

    {/* CAPTCHA */}
    <Box sx={{ mt: 2 }}>
      <ReCAPTCHA
        sitekey="6LfiPF8sAAAAANARbkYbUV-P8elwJfIb_FJEaeAH"
        onChange={handleCaptcha}
      />
    </Box>

    <Button
      type="submit"
      fullWidth
      variant="contained"
      sx={{ mt: 2 }}
      disabled={!captchaVerified || loading}
    >
      {loading ? <CircularProgress size={22} /> : "Send"}
    </Button>
  </Box>
);

}
